import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { login, guestToken } from "../../redux/auth/actions";
import { useAppDispatch } from "../../hooks/hooks";
import { useSelector } from "react-redux";
import { userProfile } from "../../redux/userProfile/action";
import { useForm } from "react-hook-form";
import storePersist from "../../redux/storePersist";
import _ from "lodash";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import PageLoader from "../../components/PageLoader";
import { toast } from "react-toastify";
import moment from "moment";
import { getHostName, getOrigin } from "../../common/services/common.service";
import { websites } from "../../redux/websites/action";
import { websiteCards } from "../../redux/websiteCards/action";
import { organizationUnits } from "../../redux/organizationUnits/action";
import { queryByStore } from "../../redux/query-by-store/action";
import { library } from "../../redux/library/action";
import { countries } from "../../redux/countries/action";
import { states } from "../../redux/states/action";
import { cmsSettings } from "../../redux/cmsSettings/action";
import bannerImage from "../../assets/img/banner3.png";
import Digiitio from "../../assets/img/digiitai.png"
export default function ManagementLogin() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const { register, handleSubmit, clearErrors, formState: { errors } } = useForm();

	const [loginValues, setLoginValues] = useState({
		Username: "",
		Password: ""
	});

	const [userType, setUserType] = useState("");
	const [colorTheme] = useDarkMode();
	const [isLoading, setIsLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
const digiitimage = Digiitio;
	const image = bannerImage;
	const account_info: any[] = [
		{
			role: "rapagent",
			title: 'Rap Agent',
		},
		{
			role: "management",
			title: 'Management',
		},

	]
	// ------------------- INIT API -------------------
	const getGuestToken = async () => {
		await dispatch(guestToken({
			loginData: [
				{
					Context: {
						bap_id: getHostName(),
						bap_uri: getOrigin(),
						timestamp: moment.utc(),
						Subscription: "Mobililty",
						Domain: "Mobility",
						SubDomains: ["Delivery"],
						Network: "RAPCustomer",
						Application: "Customer",
						Channel: "CSP"
					},
					Message: {
						AccountType: "RAPCustomer"
					}
				}
			]
		}));
	};

	const mandatoryAPICalls = async () => {
		await dispatch(websites.list({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`,
			entity: 'websites',
			jsonData: {
				Filters: [{
					FieldName: "PlatformWebSiteId",
					FilterOperatorId: 1,
					FieldValue: 30,
					FieldType: "number"
				}]
			}
		}));

		await dispatch(websiteCards.list({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`,
			entity: 'websiteCards',
			jsonData: {}
		}));
	};

	const deferredAPICalls = async () => {
		await dispatch(organizationUnits.list({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`,
			entity: 'organizationUnits',
			jsonData: {}
		}));

		await dispatch(queryByStore.list({
			url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/localization/query-by-store`,
			entity: 'queryByStores',
			jsonData: {}
		}));

		await dispatch(library.read({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`,
			entity: 'library'
		}));

		await dispatch(countries.read({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`,
			entity: 'countries'
		}));

		await dispatch(states.read({
			url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`,
			entity: 'states'
		}));

		await dispatch(cmsSettings.list({
			url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`,
			entity: 'cmsSettings',
			jsonData: {}
		}));
	};

	useEffect(() => {
		(async () => {
			try {
				await getGuestToken();
				const success = storePersist.get('guestTokenMetadata')?.current?.success;

				if (success) {
					await mandatoryAPICalls();
					await deferredAPICalls();
				}
			} catch (e) {
				console.error("Init API error:", e);
			}
		})();
	}, []);

	// ------------------- HANDLERS -------------------
	const handleChange = (value: string, field: string) => {
		setLoginValues(prev => ({ ...prev, [field]: value }));
	};

	const handleClickShowPassword = () => {
		setShowPassword(prev => !prev);
	};

	const handleForgotPassword = (e: any) => {
		e.preventDefault();
		storePersist.set('reset-pwd', 'management');
		navigate('/auth/login/forgot-password');
	};

	const onFinish = async () => {
		try {
			if (!userType) {
				toast.error("Please select user type");
				return;
			}

			setIsLoading(true);

			// -------- ROLE BASED LOGIN --------
			if (userType === "rapagent") {
				await dispatch(login({
					loginData: {
						Records: [
							{
								Context: {
									Domain: "Mobility",
									Platform: "iMove",
									Network: "RAPAgent",
									Application: "RAPAgent"
								},
								Message: {
									Username: loginValues.Username,
									Password: loginValues.Password,
									AccountType: "RAPAgent",
									LoginWithOtp: false,
									Otp: "",
									IsGoogleAuthenticated: false,
									AuthenticatedUserId: "",
									ClientIPAddress: "",
									OrganizationUnitId: 0
								}
							}
						]
					}
				}));
			}

			if (userType === "management") {
				await dispatch(login({
					loginData: {
						Records: [
							{
								Context: {
									Subscription: "MoveX",
									Domain: "Mobility",
									Network: "Internal",
									Application: "Management",
									Channel: "Portal"
								},
								Message: {
									Username: loginValues.Username,
									Password: loginValues.Password,
									AccountType: "Internal"
								}
							}
						]
					}
				}));
			}

			const resp: any = await dispatch(userProfile.read({
				url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/user-service/user-profile/me`,
				entity: 'userProfile'
			}));

			let selectedRole = "";

			const targetRoles =
				userType === "rapagent"
					? ["rapagent"]
					: ["businessowner"];

			resp.find((element: any) =>
				element?.Message?.Roles.find((role: any) => {
					if (targetRoles.includes(role?.Name?.toLowerCase())) {
						selectedRole = role.Name.toLowerCase();
						return true;
					}
					return false;
				})
			);

			if (userType === "rapagent") {
				navigate("/rap-agent/home");
			} else {
				navigate("/management/home");
			}

			setIsLoading(false);

		} catch (e: any) {
			toast.error("Login failed. Try again.");
			console.error(e);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		clearErrors();
	}, []);


	return (
		<>
			{isLoading ? <PageLoader /> : (
				<div className="flex min-h-screen w-screen overflow-hidden">

					{/* Left Banner */}

					<div className="w-1/2 ">
						<img
							src={image}
							alt="LoginS Banner"
							className="w-full h-full object-cover"
						/>
					</div>

					{/* Right Login Section */}
					<div className="w-full md:w-1/2 flex justify-center items-center bg-white">
						<div className="max-w-md w-full px-6 sm:px-8">

							{/* Logo */}
							<div className="flex justify-center mb-6">
								<img
									src={digiitimage}
									alt="Logo"
									className="h-10"
								/>
							</div>

							<h2 className="text-2xl font-semibold text-center mb-6">
								Sign in to your account
							</h2>

							<form onSubmit={handleSubmit(onFinish)}>

								<div className="mb-4">
									<label className="block text-sm text-gray-700 mb-1">
										E-mail <span className="text-red-500">*</span>
									</label>
									<input
										type="email"
										{...register('Email', {
											required: true,
											pattern:
												/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										})}
										placeholder="E-mail"
										className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
										onChange={(e) => handleChange(e.target.value, 'Username')}
										value={loginValues?.Username || ""}
									/>
									{errors.Email && (
										<span className="text-red-500 text-xs">
											Invalid email
										</span>
									)}
								</div>

								<div className="relative">
									<label className="block text-sm text-gray-700 mb-1">
										Password <span className="text-red-500">*</span>
									</label>
									<input
										type={showPassword ? "text" : "password"}
										placeholder="Password"
										className="w-full border p-2 pr-10 mb-3"
										onChange={(e) => handleChange(e.target.value, 'Password')}
									/>

									<button
										type="button"
										onClick={handleClickShowPassword}
										className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
									>
										{showPassword ? (
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke="currentColor"
												className="w-5 h-5"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
												/>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
												/>
											</svg>
										) : (
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke="currentColor"
												className="w-5 h-5"
											>
												<path
													strokeLinecap="round"
													strokeLinejoin="round"
													strokeWidth={2}
													d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
												/>
											</svg>
										)}
									</button>
								</div>

								<div className="mb-4 text-right">
									<button
										type="button"
										onClick={handleForgotPassword}
										className="text-blue-600 text-sm hover:underline"
									>
										Forgot password?
									</button>
								</div>

								<div className="mb-4">

									<div className="relative">
										<select
											className="w-full border p-2 mb-3"
											onChange={(e) => setUserType(e.target.value)}
										>
											<option value="">Select Role</option>
											{account_info.map((acc, idx) => (
												<option key={idx} value={acc.role}>
													{acc.title}
												</option>
											))}
										</select>

										<div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
											<svg
												className="w-4 h-4 text-gray-500"
												fill="none"
												stroke="currentColor"
												viewBox="0 0 24 24"
											>
											</svg>
										</div>
									</div>

									{errors.userType && (
										<span className="text-red-500 text-xs">
											Please select an option
										</span>
									)}
								</div>
								{/* Login Button */}
								<button
									type="submit"
									className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
								>
									Sign in
								</button>

								<div className="my-4 flex items-center">
									<hr className="flex-grow border-gray-300" />
									<span className="mx-2 text-gray-500 text-sm">
										Or continue with
									</span>
									<hr className="flex-grow border-gray-300" />
								</div>

								<div className="flex flex-col space-y-2">
									<button
										type="button"
										onClick={() => navigate('/sign-in-with-otp')}
										className="border border-gray-300 py-2 rounded text-sm"
									>
										Sign in with OTP
									</button>
								</div>
								<div className="my-4  flex flex-col space-y-2">
									<button
										type="button"
										onClick={() => navigate('/sign-in-with-otp')}
										className="border border-gray-300 py-2 rounded text-sm"
									>
										Sign in with Google
									</button>
								</div>

							</form>

							<div className="mt-4 text-xs text-center text-gray-500">
								<p>Terms of use - Privacy policy</p>
							</div>
							<div className="mt-4 text-xs text-center text-gray-500">
								<p>This site is protected by Digiit Business Services Privacy Policy and Terms of Service apply.</p>
							</div>

						</div>
					</div>
				</div>
			)}
		</>
	);
}